export default "__VITE_ASSET__5c11c9a9__"